export const COUCHES = [
  { id: 'dispositifs', label: 'Dispositifs en cours', court: 'Dispositifs', couleur: '#10b981', angle: 0 },
  { id: 'travaux', label: 'Travaux en cours (RCDS nominative)', court: 'Travaux', couleur: '#f59e0b', angle: 90 },
  { id: 'dommages_en_cours', label: 'Dommages en cours', court: 'Dommages en cours', couleur: '#ef4444', angle: 180 },
  { id: 'dommages_termines', label: 'Dommages terminés', court: 'Dommages terminés', couleur: '#6366f1', angle: 270 },
];
export const couche = (id) => COUCHES.find((c) => c.id === id);
// bbox : [ouest, sud, est, nord] en degrés
export const ZONES = [
  { nom: 'Antilles', bbox: [-63.6, 13.9, -60.4, 18.4] },
  { nom: 'Guyane', bbox: [-55.2, 1.9, -50.8, 6.0] },
  { nom: 'Océan Indien', bbox: [43.0, -22.6, 57.8, -11.2] },
  { nom: 'Atlantique Nord', bbox: [-57.2, 46.4, -55.6, 47.4] },
  { nom: 'Métropole', bbox: [-5.6, 41.0, 10.0, 51.4] },
];
export const VUE_ENSEMBLE = { nom: "Vue d'ensemble", bbox: null };
export const TYPES = {
  'RCDS annuelle': '#22d3ee', 'RCDS nominative': '#f59e0b', 'RCDS par période': '#a78bfa', DOMIUM: '#f472b6', RCDS: '#94a3b8',
};
export const couleurType = (t) => TYPES[t] || '#94a3b8';
